import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ErrorIcon } from '../../assets/hourglass.svg';
import {
  StyledDiv, StyledIcon, StyledParagraph, StyledTitle,
} from './TimeoutErrorPage.styles';

export interface TimeoutErrorPageProps { }

const TimeoutErrorPage: FC<TimeoutErrorPageProps> = () => {
  const { t } = useTranslation('TimeoutErrorPage');
  return (
    <StyledDiv>
      <StyledIcon as={ErrorIcon} />
      <StyledTitle data-testid="timeoutErrorTitle">{t('title')}</StyledTitle>
      <StyledParagraph data-testid="timeoutErrorMessage">
        {t('message')}
      </StyledParagraph>
    </StyledDiv>
  );
};
export default TimeoutErrorPage;
